// core
import React, { useContext } from "react";

// Components
import ProviderAddOn from "../../../../../../common/components/ProviderAddOn/ProviderAddOn";
import QuoteSpecialOffers from "../../../Components/SpecialOffer/QuoteSpecialOffers";

// styles
import styles from "./QuoteTableOffersAndBenefitsContent.module.scss";
import cx from "classnames";
import { SpecialOffer } from "../../../../../enums/SpecialOffer";
import MultiBenefitDiscountOffer from "../../../Components/MultiBenefit/MultiBenefitDiscountOffer";
import { IProviderAddon } from "../../../../../interfaces/IProviderAddon";
import QuoteTableState from "../../../../../types/quoteTable/IQuoteTableState";
import { QuoteGroupContext } from "../../../../../providers/RootContextProvider";
import { useHistory } from "react-router-dom";
import Button from "../../../../../../common/components/Forms/Button/Button";

// interfaces
interface IQuoteTableOffersAndBenefitsContentProps {
    providerId: number;
    providerName: string;
    specialOffers: SpecialOffer[];
    providerAddons: IProviderAddon[];
    cashbackAmount: number;
    hasInlineTitle?: boolean;
    quoteState: QuoteTableState;
}

// rendering
const QuoteTableOffersAndBenefitsContent: React.FC<IQuoteTableOffersAndBenefitsContentProps> = (
    props
) => {
    const {
        providerId,
        providerName,
        providerAddons,
        specialOffers,
        cashbackAmount,
        hasInlineTitle,
        quoteState
    } = props;

    if (cashbackAmount <= 0) {
        specialOffers.filter(
            (o) => !(o === SpecialOffer.CashBack20 || o === SpecialOffer.Cashback30)
        );
    }

    const hasOffers = specialOffers.length > 0 || quoteState.hasMultiBenefitDiscountOffer;

    const hasAddons = providerAddons.length > 0;

    return (
        <div className={cx([styles["quote-offer-container"], "panel-beige"])}>
            {hasInlineTitle && (
                <span className="gap-s text-font-size-s text-bold">
                    Offers and benefits
                </span>
            )}
            {hasOffers ? (
                <ul className={cx([styles["quote-offer-list"]])}>
                    {specialOffers.map((offer) => (
                        <li key={`SpecialOffer-${offer}`}>
                            <QuoteSpecialOffers
                                name={offer}
                                cashbackAmount={cashbackAmount || 0}
                            />
                        </li>
                    ))}

                    {quoteState.hasMultiBenefitDiscountOffer && (
                        <li key="mbd-option">
                            <MultiBenefitDiscountOffer
                                providerId={providerId}
                                providerName={providerName}
                            />
                        </li>
                    )}
                </ul>
            ) : (
                "None"
            )}

            {hasAddons && (
                <React.Fragment>
                    <p className="gap-ml gap-pre-ml text-font-size-s text-bold">
                        Optional
                    </p>
                    {providerAddons.map((addon) => (
                        <ProviderAddOn key={addon.addOnName} addOn={addon} size="small" />
                    ))}
                </React.Fragment>
            )}
        </div>
    );
};

export default React.memo(QuoteTableOffersAndBenefitsContent);
